module.exports = __webpack_public_path__ + "static/camera-55516532eacab9ce658e2af7e6206cff.jpg";